export const firebaseConfigSandbox = {
  apiKey: "AIzaSyD0moyxU4WCiYj0cElO-RqhKbb0QHlM1TI",
  authDomain: "lewis-sandbox-11e4e.firebaseapp.com",
  databaseURL: "https://lewis-sandbox-11e4e-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "lewis-sandbox-11e4e",
  storageBucket: "lewis-sandbox-11e4e.appspot.com",
  messagingSenderId: "1088755086764",
  appId: "1:1088755086764:web:eb056bfaaab932aa303609",
  measurementId: "undefined"
};
export const firebaseConfig = {
  apiKey: "AIzaSyDjMiurViXlCDVLT3eI_Mj1wWyimrVa8dk",
  authDomain: "lewis-bloor.firebaseapp.com",
  databaseURL: "https://lewis-bloor-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "lewis-bloor",
  storageBucket: "lewis-bloor.appspot.com",
  messagingSenderId: "412932168354",
  appId: "1:412932168354:web:c54ca23b98dee2ee3615fb",
  measurementId: "G-6DHY3SH02L"
};

        
